import type { ReactNode } from 'react';
import { useDocumentContext } from '@/features/printables/contexts/DocumentContext';
import { Flex } from '@/ui';

type Props = {
  pageIndex: number;
  children: ReactNode;
};

export const GridContainer = ({ children, pageIndex }: Props) => {
  const { isPrintEnv } = useDocumentContext();

  return (
    <Flex
      data-measure={`grid-${pageIndex}`}
      flexDirection="column"
      flexGrow={1}
      gap={isPrintEnv ? '0.3125em' : { base: '0.15em', md: '0.3125em' }}
      h="100%"
      inset={0}
      overflow={isPrintEnv ? 'hidden' : 'auto'}
      position={isPrintEnv ? 'absolute' : 'relative'}
      w="100%"
    >
      {children}
    </Flex>
  );
};
